/* eslint-disable react/prop-types */
import { Grid, MenuItem, Select } from '@mui/material';
import SoftBox from 'components/SoftBox';
import React, { useEffect, useState } from 'react'
import renderInputField from 'utils/renderInputField';
import Loading from 'components/Loading';
import { toast } from 'react-toastify';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import { getBadge } from 'services/badge.routes';
import { getMissionCategory } from 'services/mission.routes';

export default function Fields({ method, information, setInformation, handleUpdate, submit }) {
    const handleChange = (event) => {
        const { name, value } = event.target;
        setInformation({ ...information, [name]: value });
    };
    const [loading, setLoading] = useState(false);
    const [badge, setBadge] = useState([])
    const [missionCategory, setMissionCategory] = useState([])
    useEffect(() => {
        setLoading(true);
        getBadge("", false, (isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message);
            } else {
                setBadge(data);
            }
        });
        setLoading(true);
        getMissionCategory((isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message);
            } else {
                setMissionCategory(data);
            }
        });
    }, [])

    return (
        <SoftBox py={3}>
            <Loading loading={loading} />
            <SoftBox component="form" role="form">
                <Grid container spacing={3}>
                    {renderInputField("name", "نام", "text", "نام", information, handleChange)}
                    {renderInputField("description", "توضیحات", "text", "توضیحات", information, handleChange)}
                    {renderInputField("gem", "امتیاز", "text", "امتیاز", information, handleChange)}
                    {renderInputField("target", "هدف", "text", "هدف", information, handleChange)}
                    {renderInputField("percent_of_badge", "درصد نشان", "text", "بین 0 و 1", information, handleChange)}
                    {[{
                        label: "دسته بندی", name: "category_id", options: missionCategory.map(item => ({ value: item.id, label: item.name }))
                    },{
                        label: "نشان", name: "badge_id", options: badge.map(item => ({ value: item.id, label: item.name }))
                    }, { label: "نیاز به تایید", name: "need_to_approve", options: [{ value: 0, label: "خیر" }, { value: 1, label: "بله" }] }].map((selectField, index) => (
                        <Grid item xs={12} sm={6} xl={3} key={index}>
                            <SoftBox mb={1} ml={0.5}>
                                <SoftTypography component="label" variant="caption" fontWeight="bold">
                                    {selectField.label}
                                </SoftTypography>
                            </SoftBox>
                            <Select name={selectField.name} value={String(information[selectField.name])} onChange={handleChange} fullWidth>
                                {selectField.options.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                    ))}
                </Grid>
                <SoftButton
                    onClick={method !== "update" ? submit : handleUpdate}
                    style={{ marginTop: 40 }}
                    variant="gradient"
                    color="info"
                >
                    {method !== "update" ? "ثبت" : "آپدیت"}
                </SoftButton>
            </SoftBox>
        </SoftBox>
    )
}
